import {combineReducers} from 'redux'
import notariaReducer from './notariaReducer'

export default combineReducers({
    notaria: notariaReducer
})